import router from "./router";
import store from "./store";
import NProgress from "nprogress";
import cache from "./utils/cache";
import { isExternal } from "./utils/util";

const loginPath = "/account/login";
const defaultPath = "/index";
const whiteList = ["login", "factory", "factorytest", "effect"];

const addRoutesRecursively = (routes: any, parentPath = "") => {
  try {
    routes.forEach((route: any) => {
      if (isExternal(route.path)) {
        // 如果路由是外部链接，则不添加
        return;
      }
      route.meta.parentPath = parentPath;
      // 添加路由
      router.addRoute(route);

      // 递归处理子路由
      if (route.children && route.children.length > 0) {
        addRoutesRecursively(route.children, route.path);
      }
    });
  } catch (e) {
    console.error("Error adding routes:", e);
  }
};

NProgress.configure({ showSpinner: false });
router.beforeEach(async (to: any, from, next) => {
  NProgress.start();
  // 设置文档title
  to.meta?.title && (document.title = to.meta.title);

  const token = store.getters.token;
  const permission = store.getters.permission;
  if (whiteList.includes(to.name as string)) {
    // 在免登录白名单，直接进入
    next();
  } else if (token) {
    if (!permission.auth) {
      try {
        await store.dispatch("getUser");
        let { routes } = await store.dispatch("getPermission");
        addRoutesRecursively(routes);
        // 提取查找首页路由的逻辑到单独的函数，提高代码可读性和可维护性
        const findHomePageRoute = (routes: any[]) => {
          if (routes[0] && routes[0].children) {
            return routes[0].children.find(
              (item: any) => item.path === "/index",
            );
          }
          return null;
        };

        // 提取查找替代路由的逻辑到单独的函数，提高代码可读性和可维护性
        const findAlternativeRoute = (routes: any[]) => {
          const nonRootRoute = routes.find(
            (item: any) => item.path !== "/index",
          );
          if (
            nonRootRoute &&
            nonRootRoute.children &&
            nonRootRoute.children[0] &&
            nonRootRoute.children[0].children
          ) {
            return nonRootRoute.children[0].children[0]?.path;
          }
          return null;
        };

        const hasHomePage = findHomePageRoute(routes);
        const alternativeRoute = findAlternativeRoute(routes);
        if (to.path === "/") {
          next({ path: defaultPath });
          return;
        }
        if (to.path === "/index" && !hasHomePage && alternativeRoute) {
          next({ path: alternativeRoute });
          return;
        }
        if (to.path === loginPath) {
          next({ path: defaultPath });
        } else {
          next({ ...to, replace: true });
          // next()
        }
      } catch (error) {
        console.log("🚀 ~ error:", error);

        store.commit("setToken", "");
        store.commit("setUserInfo", {});
        next({ path: loginPath, query: { redirect: to.fullPath } });
        NProgress.done();
      }
    } else {
      next();
    }
  } else {
    next({ path: loginPath, query: { redirect: to.fullPath } });
  }
});

router.afterEach(() => {
  NProgress.done();
});
